function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-214.000000, -424.000000) translate(214.000000, 424.000000)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M12 4.25c4.006 0 7.579 2.827 10.302 6.398.291.38.448.857.448 1.352 0 .492-.158.973-.447 1.35-2.716 3.568-6.296 6.4-10.303 6.4-4.008 0-7.585-2.83-10.3-6.396-.292-.378-.45-.86-.45-1.354 0-.497.156-.975.447-1.35C4.422 7.074 7.992 4.25 12 4.25zm0 1.5c-3.386 0-6.65 2.583-9.113 5.812-.087.112-.137.267-.137.438 0 .169.052.327.14.442 2.453 3.22 5.723 5.808 9.11 5.808 3.386 0 6.658-2.589 9.111-5.81.086-.113.139-.273.139-.44 0-.17-.051-.326-.14-.441C18.652 8.335 15.385 5.75 12 5.75zm0 1.5c2.624 0 4.75 2.126 4.75 4.75s-2.126 4.75-4.75 4.75S7.25 14.624 7.25 12 9.376 7.25 12 7.25zm0 1.5c-1.795 0-3.25 1.455-3.25 3.25s1.455 3.25 3.25 3.25 3.25-1.455 3.25-3.25S13.795 8.75 12 8.75z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 2,
  x: -1,
  y: 11,
  rx: 1,
  transform: "translate(12.500000, 12.000000) scale(1, -1) rotate(45.000000) translate(-12.500000, -12.000000)"
}))));

var SvgIconPasswordMask = function SvgIconPasswordMask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPasswordMask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-password-mask.f2499eff.svg";
export { ForwardRef as ReactComponent };